import Icon from "../../../utils/Icon";
import {Dropdown} from "react-bootstrap";
import React from "react";
import useTabAndSorting from "./useTabAndSorting";
import {ChevronDown} from "lucide-react";

const TabsAndSorting = ({
                            screenWidth,
                            selectedTabOption,
                            devicesItems,
                            rateplansItems,
                            articlesItems,
                            supportItems,
                            onTabSelection = () => {
                            },
                            isMobile,
                            currentPage,
                            setCurrentPage,
                            updateURL = () => {},
                            search = () => {
                            },
                            handleShowFilterSection = () => {
                            },
                            selectedProductsSorting,
                            selectedProductsPerPage,
                            setSelectedProductsSorting,
                            setSelectedProductsPerPage,
                            setFiltersReady,
                            productSorting
                        }) => {

    const {
        tabs,
        productsPerPage,
        handleSortingOptionChange,
        handleProductsPerPageChange,
        labels,
        changeTab
    } = useTabAndSorting(devicesItems, rateplansItems, articlesItems, supportItems, setCurrentPage, search, updateURL, setSelectedProductsSorting, setSelectedProductsPerPage, selectedProductsSorting, selectedProductsPerPage, setFiltersReady, onTabSelection);
    return (
        <>
            <ul className="nav navigation-menu">
                {
                    tabs.map(tab => (
                        <li key={tab.id} tabIndex={0} role="navigation"
                            className={`selection-tab ${selectedTabOption === tab.id ? 'selected' : ''} ${tab.count === 0 ? 'disabled' : ''}`}>
                            <a id={`${tab.id}-tab`}
                               onClick={(e) => {
                                   e.preventDefault();
                                   changeTab(tab.id, selectedProductsPerPage?.value, selectedProductsSorting?.value, currentPage)
                               }}

                               style={tab.count === 0 ? {color: '#ccc'} : {}}>
                                {`${tab.label} (${tab.count})`}
                            </a>
                        </li>
                    ))
                }
            </ul>

            <div className="dropdown-wrapper" style={['articles', 'support'].includes(selectedTabOption)
                ? {
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: 'center',
                    width: '100%',
                }
                : {}}>
                {isMobile && (
                    selectedTabOption !== 'articles' && selectedTabOption !== 'support' && screenWidth < 1200 && (
                        <div className="product-count-dropdown">
                            <button
                                className="filter-button"
                                onClick={handleShowFilterSection}
                                style={(selectedTabOption === 'articles' || selectedTabOption === 'support') ? {marginRight: 'none'} : {}}>
                                <Icon name="filter" className="filter-button filter-icon"/>
                                <span className="label p-1" role="heading">{labels['filters']}</span>
                            </button>
                        </div>
                    ))}

                {/* Sorting & Per page */}
                <div className="dropdown-right">
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="product-count-dropdown">
                            {selectedProductsPerPage?.label || productsPerPage[0].label}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={"product-count-dropdown-menu"}>
                            {productsPerPage.map((option) => (
                                <Dropdown.Item
                                    className={"product-count-dropdown-items"}
                                    key={option.value}
                                    onClick={() => handleProductsPerPageChange(option)}
                                >
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="product-count-dropdown" role="navigation" tabIndex={0}>
                            {productSorting[selectedProductsSorting]}
                            <ChevronDown className="custom-chevron" style={{ stroke: "#90EE90", marginLeft: "10px" }}/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="custom-dropdown-menu">
                            {Object.entries(productSorting)
                                .sort((a, b) => a[0].length - b[0].length) // Sort by key length
                                .map(([key, value]) => (
                                <Dropdown.Item
                                    className="product-count-dropdown-items"
                                    key={key}
                                    onClick={() => handleSortingOptionChange(value,key)
                                }
                                >
                                    {value}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </>
    );
};

export default TabsAndSorting;